// @flow
import { createAction, createReducer } from '@reduxjs/toolkit';
import axios from 'utils/axios';

// ACTIONS

export const initialState = createAction('homes/initial');

export const findHomeStarted = createAction('homes/find_started');

export const findHomeSucceeded = createAction('homes/find_succeeded');

export const findHomeFailed = createAction('homes/find_failed');

export const fetchHomeMeetingsStarted = createAction(
  'homes/home_meetings/fetch_started'
);

export const fetchHomeMeetingsSucceeded = createAction(
  'homes/home_meetings/fetch_succeeded'
);

export const fetchHomeMeetingsFailed = createAction(
  'homes/home_meetings/fetch_failed'
);

// ACTION_CREATORS
export function flushHomeStore() {
  return async (dispatch: any) => {
    dispatch(initialState());
  };
}
export function findHomeById(homeId: string) {
  return async (dispatch: any) => {
    dispatch(findHomeStarted());

    try {
      const result = await axios.get(`/homes/${homeId}/show_public.json`);

      dispatch(findHomeSucceeded(result.data.home));
    } catch (e) {
      dispatch(findHomeFailed(e));
    }
  };
}

export function fetchHomeMeetings(homeId: string, userId: string) {
  return async (dispatch: any) => {
    dispatch(fetchHomeMeetingsStarted());

    try {
      const result = await axios.get(
        `/users/${userId}/homes/${homeId}/home_meetingss`
      );

      dispatch(fetchHomeMeetingsSucceeded(result.homeMeetings));
    } catch (e) {
      dispatch(fetchHomeMeetingsFailed(e));
    }
  };
}

// REDUCER
const INITIAL_STATE = {
  home: undefined,
  homeSchedule: [],
  isSearching: false,
  isFailRequest: false
};

export default createReducer(INITIAL_STATE, {
  [initialState]: state => {
    state.home = undefined;
    state.homeSchedule = [];
  },
  [findHomeStarted]: state => {
    state.isSearching = true;
    state.isFailRequest = false;
  },
  [findHomeSucceeded]: (state, action) => {
    state.isSearching = false;
    state.home = action.payload;
    state.homeSchedule = action.payload.homeSchedule;
  },
  [findHomeFailed]: state => {
    state.isSearching = false;
    state.isFailRequest = true;
  }
});
